<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">{{'LBL.DEVICE_SETTING' | translate}} ({{Model.StaffName}})</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="ModalContainer">
            <div class="row grdHeader p-0 m-3 border">
                <div class="col btn-group pl-0">
                    <button class="btn btn-default border bg-white iconsMargin" title="{{'TITLE.TITLE_NEW' | translate}}" (click)="addEditStaffDevice.Open(null, Model, 1)">
                        <i class="fas fa-plus fa-fw"></i>
                    </button>
                    <button class="btn btn-default border bg-white iconsMargin" title="{{'TITLE.TITLE_ENABLE_ALL' | translate}}" *ngIf="PrimaryDeviceData.length > 0 && ToggleEnable" (click)="EnableAllDevices()">
                        <i class="fas fa-check fa-fw"></i>
                    </button>
                    <button class="btn btn-default border bg-white iconsMargin" title="{{'TITLE.TITLE_DISABLE_ALL' | translate}}" *ngIf="PrimaryDeviceData.length > 0 && !ToggleEnable" (click)="DisableAllDevices()">
                        <i class="fas fa-times fa-fw"></i>
                    </button>
                </div>
            </div>
            <div class="row m-3" *ngIf="PrimaryDeviceData.length == 0">
                <span translate>LBL.NO_DEVICE</span>
            </div>
            <div class="row m-3 border" *ngIf="PrimaryDeviceData.length > 0">
                <div class="col">
                    <div class="row grdHeader pl-0 pr-0">
                        <div class="col-3 text-center border-right">
                            <span translate> LBL.DEVICE_TYPE </span>
                        </div>
                        <div class="col-4 text-center border-right">
                            <span translate> LBL.DEVICE_NUMBER </span>
                        </div>
                        <div class="col-2 text-center border-right">
                            <span translate> LBL.IS_ENABLED</span>
                        </div>
                        <div class="col-3 text-center">
                            &nbsp;
                        </div>
                    </div>
                    <div class="row" *ngFor="let row of PrimaryDeviceData" id="row.DeviceId">
                        <div class="col-3 text-center border-right ellipsis">
                            {{row.DeviceName}}
                        </div>
                        <div class="col-4 text-center border-right ellipsis">
                            {{row.DeviceNumber}}
                        </div>
                        <div class="col-2 text-center border-right" [ngSwitch]="row.IsEnabled" id="enabled_{{row.DeviceId}}">
                            <div *ngSwitchCase="true" title="{{'TITLE.TITLE_ENABLED' | translate}}"><i class="fas fa-check fa-fw"></i> </div> 
                            <div *ngSwitchCase="false" title="{{'TITLE.TITLE_DISABLED' | translate}}"><i class="fas fa-times fa-fw"></i> </div> 
                        </div>
                        <div class="col-3 text-center">
                            <a class="pr-4" (click)="addEditStaffDevice.Open(row, Model, 1)" title="{{'TITLE.TITLE_EDIT' | translate}}"><i class="fas fa-pencil-alt fa-fw"></i></a>
                            <a (click)="deleteObject.Open(row.DeviceName, row)" title="{{'TITLE.TITLE_DELETE' | translate}}"><i class="fas fa-trash fa-fw"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="ShowBackupDevice">
                <div class="row ml-3">
                    <label class="mb-0" translate>LBL.BACKUP_DEVICE</label>
                </div>
                <div class="row grdHeader p-0 m-3 border">
                    <div class="col btn-group pl-0">
                        <button class="btn btn-default border bg-white iconsMargin" title="{{'TITLE.TITLE_NEW' | translate}}" (click)="addEditStaffDevice.Open(null, Model, 2)">
                            <i class="fas fa-plus fa-fw"></i>
                        </button>
                    </div>
                </div>
                <div class="row m-3" *ngIf="BackupDeviceData.length == 0">
                    <span translate>LBL.NO_BACKUP_DEVICE</span>
                </div>
                <div class="row m-3 border" *ngIf="BackupDeviceData.length > 0">
                    <div class="col">
                        <div class="row grdHeader  pl-0 pr-0">
                            <div class="col-4 text-center border-right">
                                <span translate> LBL.DEVICE_TYPE </span>
                            </div>
                            <div class="col-5 text-center border-right">
                                <span translate> LBL.DEVICE_NUMBER </span>
                            </div>
                            <div class="col-3 text-center">
                                &nbsp;
                            </div>

                        </div>
                        <div class="row" *ngFor="let row of BackupDeviceData">
                            <div class="col-4 ellipsis text-center border-right">
                                {{row.DeviceName}}
                            </div>
                            <div class="col-5  ellipsis text-center border-right">
                                {{row.DeviceNumber}}
                            </div>
                            <div class="col-3 text-center">
                                <a class="pr-4" *ngIf="row.DeviceType != 1" (click)="addEditStaffDevice.Open(row, Model, 2)" title="{{'TITLE.TITLE_EDIT' | translate}}"><i class="fas fa-pencil-alt fa-fw"></i></a>
                                <a (click)="deleteObject.Open(row.DeviceName, row)" title="{{'TITLE.TITLE_DELETE' | translate}}"><i class="fa fa-trash fa-fw"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="DisableModalOpenEvent = false; SaveMapping()" translate>BTN.BTN_OK</button>
        <!--<button type="button" class="btn" (click)="d('dismiss')"><span translate>TWTSS.BTN_CANCEL</span></button>-->
    </div>

</ng-template>
<AddEditStaffDevice #addEditStaffDevice [PrimaryDeviceData]="PrimaryDeviceData" [BackupDeviceData]="BackupDeviceData" (CheckEnabledDevices)="AllEnabled()"></AddEditStaffDevice>
<DeleteObject #deleteObject (ObjectDeleted)="DeleteDevice($event)"></DeleteObject>
